function parseFeatureFlags () {
  const disabledFeatures = process.env.REACT_APP_DISABLED_FEATURES ?? ''
  const featuresArray = disabledFeatures.split(',')

  return {
    GLOBALHUB: !featuresArray.includes('globalhub'),
  }
}

export const ENABLED_FEATURES = parseFeatureFlags()
